import { FC } from 'react';
import { useTranslationAPI } from '../../../../translations';
import { PublicJobDetailUnderlinedSection } from '../PublicJobDetailUnderlinedSection';
import { tagModuleCodes } from '../../../../../data/translations/tagModuleCodes';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { isNull } from '../../../../../predicates/type';
import { TagsSelectorList } from '../../../../../components/TagsSelectorList';
import { TagSelector } from '../../../../../components/TagsSelectorList/types';

export const PublicJobDetailTags: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: { tags },
	} = usePublicJobDetailDataQuery();

	if (isNull(tags)) return null;

	const items: TagSelector[] = tags.tagsRef.map((tag) => ({
		id: tag.id,
		value: tag.name,
	}));

	return (
		<PublicJobDetailUnderlinedSection title={translate(tagModuleCodes.plural)}>
			<TagsSelectorList list={items} />
		</PublicJobDetailUnderlinedSection>
	);
};
